export default __webpack_public_path__ + "static/media/ic_map_northam.19960ec1.svg";